import { inject, Injectable, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DomHandlerService {
  private _document = inject(DOCUMENT);

  get bodyEl() {
    return this._document.body;
  }

  get htmlEl() {
    return this._document.getElementsByTagName('html')[0];
  }
}
